import type { StateCreator } from 'zustand';
import { produceMutation } from '@epihub/web/src/zustand/produceMutation';
import { type Conversation } from '@krishanmadan/core/src/types';
import { getStaticFirstMessage } from '@krishanmadan/core/src/model/const';
import { languageDefault } from '../lib/locale';

export type ConversationStoreSlice = {
  conversation: {
    conversation: Conversation;
    updateConversation: (cb: (prev: Conversation) => Conversation) => void;

    chatInput: string;
    setChatInput: (val: string) => void;
  };
};

export const createConversationStoreSlice: StateCreator<ConversationStoreSlice> = (set, getState) => ({
  conversation: {
    conversation: {
      messages: [
        getStaticFirstMessage(languageDefault),
      ],
    },
    updateConversation: produceMutation(set, (state, cb: (prev: Conversation) => Conversation) => {
      const previous = getState().conversation.conversation;
      state.conversation.conversation = cb(previous);
    }),

    chatInput: '',
    setChatInput: produceMutation(set, (state, val: string) => {
      state.conversation.chatInput = val;
    }),
  },
});
